import BotService from "../../services/bot.service";
import Vue from 'vue'
import AppService from "@/services/app.service";
import router from "../../router"
import $const from "@/utils/const";
import {getField, updateField} from "vuex-map-fields";
import moment from "moment";
import {make} from "vuex-pathify";

const state = {
    countOpening: 0,
    tickets: [],
    overview: {
        opening: 0,
        resolved: 0
    },
    overviewNearRealTime: {
        opening: 0,
        resolved: 0
    },
    loading: false,
    selectedChannels: [...Object.values($const.INTEGRATION_CHANNEL)],
    overviewFilter: {
        channel: '',
        from: moment().subtract(6, 'day').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
    }
}
const mutations = {
    ...make.mutations(state),
    setOverview(state, payload) {
        state.overview = payload
    },
    setCountOpening(state, countOpening) {
        state.countOpening = countOpening
    },
    setTickets(state, tickets) {
        state.tickets = tickets
    },
    setLoading(state, payload) {
        state.loading = payload
    },
    pushTicket(state, ticket) {
        state.tickets.unshift(ticket)
    },
    incrementCountOpening(state) {
        state.countOpening++
    },
    decrementCountOpening(state) {
        if (state.countOpening > 0) {
            state.countOpening--
        }
    },
    updateTicket(state, ticket) {
        let idx = state.tickets.findIndex(o => o._id === ticket._id);
        Vue.set(state.tickets, idx, ticket)
    },
    updateField,
};
const actions = {
    ...make.actions(state),
    getOverview({commit}, channels) {
        const botCode = router.currentRoute.params.bot_code;
        if (botCode) {
            commit('setLoading', true)
            BotService.getTicketsOverview(botCode, channels)
                .then(res => {
                    commit('setOverview', res.data)
                })
                .catch(() => {
                    AppService.toastError("Fetch overview ticket failed")
                })
                .finally(()=> {
                    commit('setLoading', false)
                })
        }
    },
    getOverviewByTime({commit, state}, channels) {
        const botCode = router.currentRoute.params.bot_code;
        const fromIso = moment(state.overviewFilter.from).toISOString()
        const toIso = moment(state.overviewFilter.to).add(1, 'd').toISOString()
        if (botCode) {
            commit('setLoading', true)
            BotService.getTicketsOverview(botCode, channels, fromIso, toIso)
                .then(res => {
                    commit('SET_OVERVIEW_NEAR_REAL_TIME', res.data)
                })
                .catch(() => {
                    AppService.toastError("Fetch overview ticket failed")
                })
                .finally(()=> {
                    commit('setLoading', false)
                })
        }
    },
    getTickets(context, {botCode, senderId}) {
        context.dispatch('loading/openLoading',null, {root: true});
        BotService.getTicket(botCode, senderId).then(res => {
            context.commit('setTickets', res.data.results);
            context.dispatch('loading/closeLoading',null, {root: true});
        })
    },
    getCountOpening(context, {botCode, senderId}) {
        BotService.getCountOpeningTicket(botCode, senderId).then(res => {
            context.commit('setCountOpening', res.data.count)
        })
    },
    addNewTicket({state, commit}, ticket) {
        let tktSender = ticket.sender_id,
            currentSender = router.currentRoute.params.senderId;
        if (tktSender===currentSender) {
            commit('incrementCountOpening');
            commit('pushTicket', ticket)
        }
        if (state.selectedChannels.includes(ticket.channel)) {
            Vue.set(state.overview, 'opening', state.overview.opening + 1);
        }

    },
    processCloseTicketEvent({state, commit}, ticket) {
        let tktSender = ticket.sender_id,
            currentSender = router.currentRoute.params.senderId;
        if (tktSender===currentSender) {
            commit('decrementCountOpening');
            commit('updateTicket', ticket)
        }
        if (state.selectedChannels.includes(ticket.channel)) {
            Vue.set(state.overview, 'opening', state.overview.opening - 1);
            Vue.set(state.overview, 'resolved', state.overview.resolved + 1);
        }
    },
    closeTicket(context, ticket) {
        context.dispatch('loading/openLoading', null, {root: true});
        BotService.closeTicket(ticket['app_code'], ticket._id)
            .then(() => {
                context.dispatch('loading/closeLoading', null, {root: true});
                AppService.toastInfo("Close Ticket Success")
            }).catch(() => {
                AppService.toastError("Close Ticket Failed")
        })
    }
};
const getters = {
    getField,
    concurrentTickets(state) {
        if (state.overview) {
            const totalOpening = state.overview.opening;
            const totalResolved = state.overview.resolved;
            const total = totalOpening + totalResolved;
            if (total > 0) {
                return [
                    {
                        label: "Opening",
                        value: totalOpening,
                        rate: `${((totalOpening / total) * 100).toFixed(2)} %`
                    },
                    {
                        label: "Resolved",
                        value: totalResolved,
                        rate: `${((totalResolved / total) * 100).toFixed(2)} %`
                    }
                ]
            }
        }
        return []
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}